import React from 'react';
import group from '../../images/page-about-us/group_turnover.jpg';

function Group() {
  return (
    <div className="group">
      <img src={group} alt="Group" />
    </div>
  );
}

export default Group;
